<template>
  <LazyModulesKursusMateri>
    <slot />
  </LazyModulesKursusMateri>
</template>
